<template>
  <div>
    <b-form @submit="addProduct">
      <b-row>
        <b-col lg="8">
          <h5>
            Product details
          </h5>
        </b-col>
        <b-col>
          <p class="text-right">
            <b-button-group>
              <!-- <button :href="`record/product-production.xlsx`" variant="outline-primary" class="mr-1" download>
          <b-icon icon="download"></b-icon> 업로드양식
        </button> -->
              <b-button size="sm" :href="`record/product-production.xlsx`" class="text-left mr-1" variant="outline-dark"
                squared download>
                <b-icon class="text-left" icon="download"></b-icon>
                업로드양식
              </b-button>
              <b-button size="sm" class="text-left mr-1" variant="outline-dark" squared download
                @click="$refs.file.click()">
                <b-icon class="text-left" icon="upload"></b-icon> 제품업로드
              </b-button>
            </b-button-group>

            <b-button squared size="sm" type="submit" class="text-right" variant="outline-primary">
              <b-icon icon="plus"></b-icon> 생산제품 추가
            </b-button>
          </p>
        </b-col>
      </b-row>
      <b-row v-for="data, idx of param.productDetails" :key="idx" align-v="center" class="mt-1">
        <b-col lg="3">
          <b-input-group class="mb-1">
            <b-form-select v-if="!data.productName" v-model="data.product" :options="productDetails" required :state="validateState('product', idx)">
              <template #first>
                <b-form-select-option :value="null" disabled>제품선택</b-form-select-option>
              </template>
            </b-form-select>
            <b-input v-else v-model="data.productName" required :state="validateState('product', idx)"></b-input>
          </b-input-group>
        </b-col>
        <b-col lg="3">
          <b-input-group class="mb-1">
            <b-input v-model="data.lotNo" placeholder="로트번호 - Lot No" required :state="validateState('lotNo', idx)">
            </b-input>
          </b-input-group>
        </b-col>
        <b-col lg="3">
          <b-input-group class="mb-1">
            <b-input v-model="data.quantity" type="number" placeholder="제품수량 - Quantity" required
              :state="validateState('quantity', idx, 0)"></b-input>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group class="mb-1">
            <b-form-select v-model="data.uom" :options="uoms" required :state="validateState('uom', idx)">
              <template #first>
                <b-form-select-option :value="null" disabled>제품단위선택</b-form-select-option>
              </template>
            </b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="1" v-if="param.productDetails.length > 1">
          <b-button @click="deleteRows(idx)" variant="outline-dark" v-b-tooltip.hover.right title="제품삭제">
            <b-icon icon="trash" scale="1"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <input type="file" ref="file" style="display: none" @change="importExcel" />
    <p></p>
  </div>
</template>

<script>

// import FromSelectProduct from '../../FromSelectProduct.vue'
// import FromSelectFacility from '../../FromSelectFacility.vue'
import hal from 'hateoas-hal-link-resolver'
import ButtonGroups from '../../../../buttons/ButtonGroups.vue'
// import xlsx from 'xlsx'
import XLSX from 'xlsx';
// @/views/yysoft/user/User
// utils/OverayVue

const form = {
  product: null,
  lotNo: null,
  uom: null,
  quantity: null,
}

export default {
  props: {
    scenario: {
      type: Object
    },
    param: {
      type: Object
    }
  },
  components: {
    ButtonGroups
    // OverayVue,
    // FromSelectProduct,
    // FromSelectFacility
  },

  beforeMount() {
    if(this.param.productDetails && this.param.productDetails.length == 0) {
      this.addProduct();
    }
    
  },
  data() {
    return {
      // onComplate: false,
    }
  },
  methods: {
    addProduct() {
      this.param.productDetails.unshift(Object.assign({}, form))
    },
    deleteRows(idx) {
      this.param.productDetails.splice(idx, 1)
    },
    filechange(e) {
      console.log(e)
    },
    importExcel(event) {
      const file = event.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        let data = reader.result;
        // let data = e.target.result;
        let workbook = XLSX.read(data, { type: 'binary' });
        workbook.SheetNames.forEach(sheetName => {
          const datas = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          this.param.productDetails = datas.map(d => {
            return {
              product: this.findProduct(d['제품명']),
              lotNo: d['로트번호'],
              uom: d['제품단위'],
              quantity: d['제품수량'],
            }
          });
          this.$refs.file.value = null;
        });
      };
      reader.readAsBinaryString(file);
      // console.log(items)
    },
    findProduct(name) {
      const product = this.scenario.products.find(p => p.productName == name);
      if (!product) return null;
      return hal(product, 'self');
    },

    
    paramChange() {
      this.$emit('OnValidate', true);
    },
    _check(obj){

      // console.log('==> ', obj)
      return obj == null ? null : (obj? true: false);
    },
    _checkType(obj) {
      console.log(obj.length)
      if(obj.length > 0) {
        if(isNaN(obj)) {
          console.log('문자입니다. => ', obj)
        }else {

          return new String(obj).trim() ? true : false;

          // console.log('숫자입니다. => ', obj)
        }
      }else {
        return false;
      }
    },
    validateState(field, idx, cnt) {
      const val = this.param.productDetails[idx][field];
      return this._check(val) && (cnt != undefined ? val > cnt : true);
    },
  },
  computed: {
    uoms() {
      const uoms = this.$getUoms();
      const keys = Object.keys(uoms);
      return keys.map(k => {
        return {
          value: k, text: uoms[k]
        }
      });

    },
    productDetails() {
      return this.scenario.products.map(p => {
        return { text: p.productName, value: hal(p, 'self') }
      })
    }
  },
  watch: {
    'param.productDetails': {
      deep: true,
      handler: 'paramChange'
    }
  }
}
</script>